import { useState } from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import Card from '@/entities/Card';
import { getPercent } from '@/shared/utils/formatters';
import * as StatsIndicator from '@/shared/ui/StatsIndicator';
import { SharesChart } from '~/sha256/Shares';
import { useGetMinerWorkersQuery } from '@/shared/api/Workers';
import { 
  selectDateRange,
  selectPollingInterval, 
} from "@/processes/Settings";
import { useMinerAccount } from "@/processes/MinerAccounts";

type SharesWidgetProps = {
  className?: string;
}

const SharesWidget = (props: SharesWidgetProps) => {
  const { className } = props;
  const intl = useIntl();
  const dateRange = useSelector(selectDateRange);
  const pollingInterval = useSelector(selectPollingInterval);
  const { account, miner, coin } = useMinerAccount();
  const [visibleChartBars, setVisibleChartBars] = useState([]);

  const { data: minerWorkers = [], isSuccess: isMinerWorkersSuccess } = useGetMinerWorkersQuery({ 
    coin,
    account,
    miner,
    dateRange,
  }, { pollingInterval, skip: !(account || miner) });

  const validSharesTotal = String(_get(minerWorkers, 'validSharesTotal', 0));
  const staleSharesTotal = String(_get(minerWorkers, 'staleSharesTotal', 0));
  const invalidSharesTotal = String(_get(minerWorkers, 'invalidSharesTotal', 0));
  const validRateTotal = _get(minerWorkers, 'validRateTotal', 0);
  const staleRateTotal = _get(minerWorkers, 'staleRateTotal', 0);
  const invalidRateTotal = _get(minerWorkers, 'invalidRateTotal', 0);

  return (
    <Card className={className} title={intl.formatMessage({ id: 'shares' })}>
      <StatsIndicator.Group 
        className="flex -mx-2 my-4"
        selectedItems={visibleChartBars}
        onChange={(items) => setVisibleChartBars(items)}
      >
        <StatsIndicator.Item
          name="validCount"
          size='l'
          className='mx-2'
          status='success'
          isLoading={false}
          title={intl.formatMessage({ id: 'shares.valid' })}
          value={validSharesTotal}
          subValue={validRateTotal ? getPercent(validRateTotal) : ''}
        />
        {/* <StatsIndicator.Item
          name="staleCount"
          size='l'
          className='mx-2'
          status='warning'
          isLoading={!isMinerWorkersSuccess}
          title={intl.formatMessage({ id: 'shares.stale' })}
          value={staleSharesTotal}
          subValue={staleRateTotal ? getPercent(staleRateTotal) : ''}
        /> */}
        <StatsIndicator.Item
          name="invalidCount"
          size='l'
          className='mx-2'
          status='error'
          isLoading={false}
          title={intl.formatMessage({ id: 'shares.rejected' })}
          value={invalidSharesTotal}
          subValue={invalidRateTotal ? getPercent(invalidRateTotal) : ''}
        />
      </StatsIndicator.Group>

      <SharesChart visibleChartBars={visibleChartBars}/>
    </Card>
  );
}

export default SharesWidget;
